import { ExperienceType, ExperienceVerificationStatusType } from '@apply/constants';

export function normalizeNonBFIUserExperienceForApi(exp: any) {
    return {
        id: exp.id ?? 0,
        projectTypeId: exp.projectTypeId ?? null,
        experienceTypeId: exp.experienceTypeId ?? ExperienceType.NonBfi, //Only NONBFI is Edited or Saved
        propertyTypeId: exp.propertyTypeId ?? null,
        twoToFourUnitTypeId: exp.twoToFourUnitTypeId ?? null,
        lender: exp.lender ?? null,
        principalId: exp.principalId ?? 0,

        address: {
            street1: exp.address?.street1 ?? null,
            street2: exp.address?.street2 ?? null,
            city: exp.address?.city ?? null,
            state: exp.address?.state ?? null,
            zipCode: exp.address?.zipCode ?? null,
            county: exp.address?.county ?? null,
        },

        stillOwn: exp.stillOwn ?? null,

        dateSold: exp.dateSold ? new Date(exp.dateSold).toISOString().split('T')[0] : null,

        dateSoldTypeId: exp.dateSoldTypeId ?? null,
        salesPrice: exp.salesPrice ? Number(exp.salesPrice) : null,
        budget: exp.budget ? Number(exp.budget) : null,
        unitCount: exp.unitCount ?? null,

        isVerified: exp.isVerified ?? null,
        homeConstructedAfterPurchase: exp.homeConstructedAfterPurchase ?? null,
        commercialConsiderationAcknowledged: exp.commercialConsiderationAcknowledged ?? null,
        verificationStatusTypeId: exp.verificationStatusTypeId ?? ExperienceVerificationStatusType.Submitted,

        content: exp.content ?? null,
    };
}
